import styled from 'styled-components';
import { container, fontSize, screen, spacing } from 'theme';

export const StyledFooter = styled.div`
  background-color: #fbedff;
  padding: ${spacing('xl4')} ${spacing('md')};
`;

export const StyledIrregularBoxContainer = styled.div<{
  $src: string;
}>`
  background-image: ${({ $src }) => `url(${$src})`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  max-width: ${container('md')};

  padding: ${spacing('md')} ${spacing('xl')} ${spacing('xl3')} ${spacing('xl2')};
  margin: auto;
  gap: ${spacing('xl')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
`;

export const StyledContent = styled.div`
  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;
